import React from 'react'

const RoundBlueButton = ({ icon, onClick, className, ...props }) => (
    <button className={'round-blue-button' + (className ? ` ${className}` : '')} onClick={onClick} {...props}>
        {icon}
    </button>
)

export default RoundBlueButton
